/**
 * Platform API error codes related to password creation/reset.
 *
 * Returned inside the `message` array of a 4xx response body, e.g.:
 * ```json
 * {
 *   "statusCode": 422,
 *   "message": [{ "code": "108", "message": "Password was already used before." }],
 *   "timestamp": "2026-09-02T16:36:28.863Z"
 * }
 * ```
 */
export const PASSWORD_ERROR_CODES = {
  /** User already has a registered password */
  ALREADY_EXISTS: '17',
  /** New password matches one previously used by the user */
  ALREADY_USED: '108',
} as const;

/**
 * Translation key shown when the new password repeats a previously used one.
 */
export const PASSWORD_ALREADY_USED_MESSAGE_KEY =
  'The new password cannot be the same as a previously used password. Try a different combination.';
